import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDataFetch } from "../../../hooks/useDataFetch";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("El nombre es obligatorio"),
  email: Yup.string().email("El formato del correo electrónico no es válido"),
  password: Yup.string().required("La contraseña es obligatoria"),
});

const StudentCreate = ({ refetchStudent }) => {
  const {  postData } = useDataFetch();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { mutate: createAdmin, isLoading: isPostLoading } = postData(
    "/register",
    {},
    {},
    {
      onSuccess: (data) => {
        refetchStudent();
        reset();
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const onSubmit = (data) => {
    createAdmin(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div
          className={`col-md-4 mb-3 ${
            errors.name?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Nombres</label>
          <input type="text" className="form-control" {...register("name")} />

          {errors.name?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.name?.message}
            </div>
          ) : null}
        </div>
        <div
          className={`col-md-4 mb-3 ${
            errors.email?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Correo electrónico</label>
          <input type="text" className="form-control" {...register("email")} />

          {errors.email?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.email?.message}
            </div>
          ) : null}
        </div>

        <div
          className={`col-md-4 mb-3 ${
            errors.password?.message ? "is-invalid" : "is-valid"
          }`}
        >
          <label htmlFor="firstName">Contraseña</label>
          <input
            type="password"
            className="form-control"
            {...register("password")}
          />

          {errors.password?.message ? (
            <div className="invalid-feedback" style={{ display: "block" }}>
              {errors.password?.message}
            </div>
          ) : null}
        </div>
      </div>

      <hr className="mb-4" />
      <button
        className="btn btn-primary btn-lg btn-block"
        type="submit"
        disabled={isPostLoading}
      >
        Guardar
      </button>
    </form>
  );
};

export default StudentCreate;
